import { render, staticRenderFns } from "./BackgroundColorLink.vue?vue&type=template&id=023ac0ac&scoped=true&"
import script from "./BackgroundColorLink.vue?vue&type=script&lang=js&"
export * from "./BackgroundColorLink.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundColorLink.vue?vue&type=style&index=0&id=023ac0ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023ac0ac",
  null
  
)

export default component.exports